import { useFakedUID } from "./useFakeUID";
import useFirebaseData from "./useFirebaseData";
import type { FirebaseRecord, Project } from "../types";

const useFirebaseProjects = () => {
  const uid = useFakedUID();
  return useFirebaseData<FirebaseRecord<Project>>(uid ? `/userdata/${uid}/projects` : null);
};

export default useFirebaseProjects;
